import { render, staticRenderFns } from "./funding-commitments-viewer.vue?vue&type=template&id=9ae2ee4e&scoped=true"
import script from "./funding-commitments-viewer.vue?vue&type=script&lang=js"
export * from "./funding-commitments-viewer.vue?vue&type=script&lang=js"
import style0 from "./funding-commitments-viewer.vue?vue&type=style&index=0&id=9ae2ee4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae2ee4e",
  null
  
)

export default component.exports